export default {
  'pages.layouts.userLayout.title': '企业办公自动化管理系统',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '用户名或密码错误',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '请输入用户名/邮箱/手机号',
  'pages.login.username.required': '请输入用户名！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '请输入密码！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '手机号格式错误！',
  'pages.login.captcha.placeholder': '请输入验证码',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '记住我（30天）',
  'pages.login.forgotPassword': '忘记密码',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.organization.title': '组织架构管理',
  'pages.organization.subTitle': '查看和管理企业组织架构',
  'pages.organization.sync': '同步组织架构',
  'pages.organization.refresh': '刷新',
  'pages.organization.syncSuccess': '同步成功',
  'pages.organization.syncFailed': '同步失败',
  'pages.organization.getFailed': '获取组织架构失败',
  'pages.organization.departmentCount': '共 {count} 个部门',
  'pages.organization.noData': '暂无数据，请点击同步组织架构按钮获取数据',
  'pages.organization.loading': '加载中...',
  'pages.organization.disabled': '已停用',
  'pages.user.title': '用户管理',
  'pages.user.subTitle': '查看和管理系统用户',
  'pages.user.sync': '同步企业微信用户',
  'pages.user.create': '新建用户',
  'pages.user.edit': '编辑用户',
  'pages.user.delete': '删除用户',
  'pages.user.resetPassword': '重置密码',
  'pages.user.bindWechat': '绑定企业微信',
  'pages.user.deleteConfirm': '确定要删除用户 "{name}" 吗？',
  'pages.user.deleteSuccess': '删除用户成功',
  'pages.user.deleteFailed': '删除用户失败',
  'pages.user.createSuccess': '创建用户成功',
  'pages.user.createFailed': '创建用户失败',
  'pages.user.updateSuccess': '更新用户成功',
  'pages.user.updateFailed': '更新用户失败',
  'pages.user.syncSuccess': '同步成功！共同步 {count} 个用户',
  'pages.user.syncFailed': '同步失败',
  'pages.user.resetPasswordSuccess': '重置密码成功',
  'pages.user.resetPasswordFailed': '重置密码失败',
  'pages.user.bindWechatSuccess': '绑定企业微信成功',
  'pages.user.bindWechatFailed': '绑定企业微信失败',
  'pages.approval.template.title': '审批模板管理',
  'pages.approval.template.create': '新建模板',
  'pages.approval.template.edit': '编辑模板',
  'pages.approval.template.delete': '删除模板',
  'pages.approval.template.viewDetail': '查看详情',
  'pages.approval.template.templateId': '模板ID',
  'pages.approval.template.templateName': '模板名称',
  'pages.approval.template.templateType': '模板类型',
  'pages.approval.template.description': '描述',
  'pages.approval.template.status': '状态',
  'pages.approval.template.createSuccess': '创建模板成功',
  'pages.approval.template.createFailed': '创建模板失败',
  'pages.approval.template.updateSuccess': '更新模板成功',
  'pages.approval.template.updateFailed': '更新模板失败',
  'pages.approval.template.getDetailSuccess': '获取模板详情成功',
  'pages.approval.template.getDetailFailed': '获取模板详情失败',
  'pages.approval.templateType.vacation': '请假',
  'pages.approval.templateType.expense': '报销',
  'pages.approval.templateType.administrative': '行政',
  'pages.approval.templateType.custom': '自定义',
  'pages.approval.status.active': '启用',
  'pages.approval.status.inactive': '停用',
  'pages.approval.application.title': '审批申请',
  'pages.approval.application.myApproval': '我的审批',
  'pages.approval.application.allApproval': '全部审批',
  'pages.approval.application.submit': '发起审批',
  'pages.approval.application.viewDetail': '查看详情',
  'pages.approval.application.refresh': '刷新状态',
  'pages.approval.application.spNo': '审批单号',
  'pages.approval.application.templateName': '审批类型',
  'pages.approval.application.applicantName': '申请人',
  'pages.approval.application.applyTime': '申请时间',
  'pages.approval.application.spStatus': '审批状态',
  'pages.approval.application.submitSuccess': '提交审批成功',
  'pages.approval.application.submitFailed': '提交审批失败',
  'pages.approval.application.getDetailSuccess': '获取审批详情成功',
  'pages.approval.application.getDetailFailed': '获取审批详情失败',
  'pages.approval.application.refreshSuccess': '刷新状态成功',
  'pages.approval.application.refreshFailed': '刷新状态失败',
  'pages.approval.spStatus.1': '审批中',
  'pages.approval.spStatus.2': '已通过',
  'pages.approval.spStatus.3': '已驳回',
  'pages.approval.spStatus.4': '已撤销',
  'pages.approval.spStatus.6': '通过后撤销',
  'pages.approval.spStatus.7': '已删除',
  'pages.approval.spStatus.10': '已支付',
};
